import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DistribuidorMantenedorModel } from '../../models/distribuidorMantenedorModel';
import { CatalogoService } from '../../services/catalogo.service';
import { distribuidorModulo } from '../../diccionarios/distribuidorModulo';
import { DistribuidorService } from '../../services/distribuidor.service';
import { SellInModel, SellInModelInterface } from '../../models/sellinModel';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-upload-csv-sellin',
  templateUrl: './upload-csv-sellin.component.html',
  styleUrls: ['./upload-csv-sellin.component.css']
})
export class UploadCsvSellinComponent implements OnInit {

  titulo = 'Presupuesto Sell In';
  mostrarFormulario = false;

  textoBuscar: string;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  frameworkComponents: any;
  rowSelection: any;
  rowData: any[] = [];

  textoBuscarCli: string;
  gridApiCli: any;
  gridColumnApiCli: any;
  columnDefsCli: any[];
  frameworkComponentsCli: any;
  rowSelectionCli: any;
  rowDataCli: any[] = [];

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  loading: boolean = false;
  listaVacia: boolean = true;

  distribuidorModulo: any = {};


  DAT_BTNS: any;
  DAT_MSG: any;
  DAT_BTNCSS: any;

  csv: string;
  objSelected: any = {};

  cmbDistribuidor: DistribuidorMantenedorModel[] = [];
  listaVaciaCli: boolean = true;

  errorData: boolean = true;
  modelGrid: SellInModelInterface;

  dataSellin: SellInModel = {
    idDistribuidor: '',
    anio: 0,
    mes: 0,
    articulo: '',
    contenedor: '',
    presupuestoKilo: 0,
    presupuestoCaja: 0,
    presupuestoImporte: 0,
    error: null,
    correct: false,
    devolverModeloGridSellin() {
      return null
    }
  };

  constructor(public fb: FormBuilder,
    private _util: UtilsService,
    private _distribuidor: DistribuidorService,
    private catalogo: CatalogoService,
  ) { }

  ngOnInit() {
    this.formulario = this.fb.group({
      idDistribuidor: [''],
      multipart: ['', [Validators.required]],
    });
    const innClase = new SellInModel();
    this.modelGrid = innClase.devolverModeloGridSellin();
    this.distribuidorModulo = distribuidorModulo;
    this.DAT_BTNS = this.distribuidorModulo.button.buttonsNombre;
    this.DAT_MSG = this.distribuidorModulo.mensajes;
    this.DAT_BTNCSS = this.distribuidorModulo.button.buttonsCss;
    this.cargarIconosFiltros();
    this.cargarGrid();
    this.cargarGridCli();
    this.getDistribuidor();
  }

  /** FUNCIONES */

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReadyCli(params) {
    this.gridApiCli = params.api;
    this.gridColumnApiCli = params.columnApi;
  }

  onQuickFilterChangedCli() {
    this.gridApiCli.setQuickFilter(this.textoBuscarCli);
  }

  cargarIconosFiltros() {
    this.csv = this.catalogo.catalogoAsesorIcon().csv;
  }

  cargarGrid() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',
          colorBoton: 'btn btn-link'
        }
      },
      {
        headerName: 'ESTADO',
        sortable: true,
        filter: true,
        width: 200,
        cellStyle: this.changeRowColor.bind(this),
        valueGetter: function (params: any) {
          return (params.data.correct === true) ? 'CORRECTO' : 'INCORRECTO';
        }
      },
      {
        headerName: 'DISTRIBUIDOR',
        field: this.modelGrid.idDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'ARTICULO',
        field: this.modelGrid.articulo,
        sortable: true,
        filter: true,
        width: 160
      },
      // {
      //   headerName: 'CONTENEDOR',
      //   field: this.modelGrid.contenedor,
      //   sortable: true,
      //   filter: true,
      //   width: 150
      // },
      {
        headerName: 'MES',
        field: this.modelGrid.mes,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'AÑO',
        field: this.modelGrid.anio,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'CAJA',
        field: this.modelGrid.presupuestoCaja,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'IMPORTE',
        field: this.modelGrid.presupuestoImporte,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'KILO',
        field: this.modelGrid.presupuestoKilo,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'DET.ERROR',
        field: 'error.errorCampo',
        cellStyle: this.changeRowColor.bind(this),
        sortable: true,
        filter: true,
        width: 450
      }
    ];
    this.rowSelection = 'multiple';
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.correct != undefined) {
      if (data.correct === true) {
        return {
          'background-color': 'lightgreen',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      } else {
        return {
          'background-color': '#FFC0CB',
          'color': 'black',
          'font-weight': 'bold',
          'font-size': '14px'
        };
      }
    }
    return null;
  }

  cargarGridCli() {
    this.frameworkComponentsCli = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.columnDefsCli = [
      {
        headerName: 'DISTRIBUIDOR',
        field: this.modelGrid.idDistribuidor,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'ARTICULO',
        field: this.modelGrid.articulo,
        sortable: true,
        filter: true,
        width: 160
      },
      // {
      //   headerName: 'CONTENEDOR',
      //   field: this.modelGrid.contenedor,
      //   sortable: true,
      //   filter: true,
      //   width: 160
      // },
      {
        headerName: 'MES',
        field: this.modelGrid.mes,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'AÑO',
        field: this.modelGrid.anio,
        sortable: true,
        filter: true,
        width: 140
      },
      {
        headerName: 'CAJA',
        field: this.modelGrid.presupuestoCaja,
        sortable: true,
        filter: true,
        width: 160
      },
      {
        headerName: 'IMPORTE',
        field: this.modelGrid.presupuestoImporte,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'KILO',
        field: this.modelGrid.presupuestoKilo,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.callModal.bind(this),
          label: 'Ver',
          colorBoton: 'btn btn-link'
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 120,
        cellRendererParams: {
          onClick: this.eliminarElemento.bind(this),
          label: this.DAT_BTNS.eliminar,//buttons.eliminar,
          colorBoton: 'btn btn-link'//'btn btn-danger btn btn-block'
        }
      },
    ];
    this.rowSelectionCli = 'multiple';
  }

  /** SERVICIOS */
  getDistribuidor() {
    this._distribuidor.getDistribuidor().subscribe((res: DistribuidorMantenedorModel[]) => {
      this.cmbDistribuidor = res;
      this.cmbDistribuidor = this.cmbDistribuidor.map((e) => {
        e.descripcion = e.idDistribuidor + ' ' + e.nombreDistribuidor;
        return e;
      });
    }, (err: any) => {
      this.cmbDistribuidor = [];
      console.log(err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  obtenerObjetoDistribuidor(event) {
    this.objSelected = event[0];
    if (this.objSelected != undefined) {
      this.formulario.get('idDistribuidor').setValue(this.objSelected.idDistribuidor);
      this.getAllSellIn(this.objSelected.idDistribuidor);
    } else {
      this.formulario.get('idDistribuidor').setValue('');
      this.rowDataCli = [];
      this.listaVaciaCli = true;
    }
  }

  getAllSellIn(idDistribuidor: string) {
    this._distribuidor.getAllSellin(idDistribuidor).subscribe((res: any[]) => {
      this.rowDataCli = res;
      this.listaVaciaCli = this.rowDataCli.length === 0 ? true : false;
    }, (err: any) => {
      this.rowDataCli = [];
      this.listaVaciaCli = true;
      this._util.mensajeErroToast(err.error.mensaje);
    });
  }

  onFileSelect(event) {
    let allowedExtensions = /(.csv)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formulario.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, el tipo de archivo permitido es "CSV" ', true, 9000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formulario.get('multipart').setValue(file);
      }
    }
  }

  setFormData(data: any): FormData {
    const formData = new FormData();
    // formData.append('multipart', data.multipart);
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    return formData;
  }

  enviarFormulario() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea enviar el siguiente archivo?',
        text: '',
        action: 'Enviar',
        funcion: this._distribuidor.postUploadFileSellin(this.setFormData(this.formulario.value), this.formulario.get('idDistribuidor').value),
        loading: true,
        context: this,
      }
    ).then((res: any[]) => {
      this.mostrarFormulario = true;
      this.rowData = res;
      if (this.rowData.length > 0) {
        this.listaVacia = false;
        this.validarRowData();
      } else {
        this.listaVacia = true;
      }
    }).catch((err) => {
      console.log('Error ' + err);
      this.rowData = [];
      this.listaVacia = true;
    });
  }

  validarRowData() {
    this.errorData = true;
    this.rowData.forEach(e => {
      if (!e.correct) {
        this.errorData = false;
      }
    });
  }

  descargarCsv() {
    //EJEMPLO DE INVOCACION NO DESCOMENTAR
    let cabecera: any[] = [['ESTADO', 'DISTRIBUIDOR', 'ARTICULO',
      'MES', 'AÑO', 'CAJA', 'IMPORTE', 'KILO', 'ERROR']];
    const clonLista = this.rowData.map((x) => Object.assign({}, x));
    const data: any[] = [];
    clonLista.forEach((e) => {
      if(e.error) {
        data.push({
          'ESTADO': (e.correct === true) ? 'CORRECTO' : 'INCORRECTO',
          'DISTRIBUIDOR': e.idDistribuidor,
          'ARTICULO': e.articulo,
          'MES': e.mes,
          'AÑO': e.anio,
          'CAJA': e.presupuestoCaja,
          'IMPORTE': e.presupuestoImporte,
          'KILO': e.presupuestoKilo,
          'ERROR': (e.error.errorCampo === undefined) ? '' : (e.error.errorCampo === '') ? '' : e.error.errorCampo,
        });
      }      
    });
    let name: string = "data.csv";
    this._util.exportCSV(cabecera, data, name);
  }

  guardar() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar el siguiente listado de Sell In?',
        text: '',
        action: 'Guardar',
        funcion: this._distribuidor.postSaveFileSellin(this.rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje, true, 3000);
    });
  }

  regresar() {
    this.mostrarFormulario = false;
    this.rowData = [];
    this.rowDataCli = [];
    this.listaVaciaCli = true;
    this.formulario.reset();
  }

  eliminarElemento({ rowData }) {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea Eliminar la siguiente registro?',
        text: '',
        action: 'Eliminar',
        funcion: this._distribuidor.deleteSellin(rowData),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      // this.regresar();
      this.formulario.get('idDistribuidor').setValue(this.objSelected.idDistribuidor);
      this.getAllSellIn(this.objSelected.idDistribuidor);
    }).catch((err) => {
      console.log('Error ' + err);
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  callModal({ rowData }) {
    this.dataSellin = rowData;
    document.getElementById('abrirModal').click();
  }
}
